import IconButton from '@mui/joy/IconButton'
import Delete from '@mui/icons-material/Delete'

export const DeleteButton = ({ onClick }) => (
    <IconButton variant="soft" color="danger" onClick={onClick}>
        <Delete />
    </IconButton>
)
